<template>
  <div :class="['label', { disabled: disabled }]" @click="toggle">
    <template v-if="!searchable">
      <span v-if="shouldShowPlaceholder" class="placeholder">{{ placeholder }}</span>
      <span v-else>{{ selectedItemValue }}</span>
    </template>
    <template v-else>
      <div
        ref="dropdownSearchInput"
        class="dropdownSearchInput"
        contenteditable
        :placeholder="placeholder"
        @focus.prevent="emitFocusEvent"
        @keyup="onKeyup"
        @keydown.enter.prevent
        v-text="searchablePlaceholder">
      </div>
    </template>
    <div class="arrow" :class="{ expanded: opened }"></div>
  </div>
</template>

<script>
  import { debounce, get } from 'lodash';

  export default {
    name: 'ihu-select-dropdown',
    props: {
      selectedItem: {
        type: Object,
        default: () => ({}),
      },
      itemValueAttr: {
        type: String,
        default: 'value',
      },
      placeholder: {
        type: String,
        default: 'Please Select',
      },
      opened: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      searchable: {
        type: Boolean,
        default: false,
      },
      searchTerm: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        visible: false,
        searchInputText: this.searchTerm || '',
      };
    },
    computed: {
      selectedItemValue() {
        return this.selectedItem ? this.selectedItem[this.itemValueAttr] : '';
      },
      shouldShowPlaceholder() {
        return this.selectedItemValue == null && this.placeholder;
      },
      searchablePlaceholder() {
        if (this.opened) {
          return this.searchInputText;
        }
        return this.selectedItemValue || this.placeholder;
      },
    },
    watch: {
      searchTerm() {
        if (this.searchTerm === '') {
          this.$refs.dropdownSearchInput.innerText = '';
        }
      },
    },
    methods: {
      toggle() {
        this.$emit('toggle', !this.opened);
        if (this.searchable) {
          this.$refs.dropdownSearchInput.focus();
        }
      },
      emitFocusEvent() {
        this.$emit('emitFocusEvent', true);
      },
      onTagInputValueChange() {
        if (!this.disabled) {
          const text = get(this.$refs, 'dropdownSearchInput.innerText', '');
          this.$emit('input', text);
        }
      },
      onKeyup: debounce(function searchInput() {
        this.onTagInputValueChange();
      }, 150),
    },
  };
</script>

<style scoped lang="scss">
.dropdownSearchInput {
  width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
  .label {
    cursor: pointer;

    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    @include themify {
      background: getColor('ihu-select-bg', 'ihu');
      border-color: getColor('ihu-select-border', 'ihu');
    }

    min-width: 198px;
    min-height: 38px;

    font-size: 14px;
    line-height: 150%;
    display: flex;
    flex-direction: row;
    padding-left: 12px;
    align-items: center;

    .arrow {
      position: absolute;
      right: 10px;
      top: 40%;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top-width: 5px;
      border-top-style: solid;
      @include themify {
        border-top-color: getColor('ihu-select-arrow-color', 'ihu');
      }
      transform: rotateZ(0deg) translateY(0px);
      transition-duration: 0.3s;
      transition-timing-function: cubic-bezier(.59,1.39,.37,1.01);

      &.expanded {
        transform: rotateZ(180deg) translateY(2px);
      }
    }
  }
</style>
